module.exports = __webpack_public_path__ + "static/media/Electrician.e627e19b.jpg";